import { getPlanLabelAndValue } from 'constants/subscription-tenant';
import { SubscriptionPlansResult } from 'interfaces/subscriptions-tenant.interface';
import { LabelWithValue } from 'shared-components';
import { cn } from 'utils/global';

interface Props {
  plans: SubscriptionPlansResult[];
  isLoading: boolean;
  isFree: boolean;
}

const SubscriptionPlans = ({ plans, isLoading, isFree }: Props) => {
  if (!plans?.length) {
    return null;
  }

  return (
    <h6 className={cn('mx-5 min-h-[5rem]', { 'text-center': isFree })} data-cy="plans">
      {plans.map((plan) => {
        const { label, value } = getPlanLabelAndValue(plan, isFree);

        return (
          <LabelWithValue
            key={plan.id}
            bodyClassName={cn('text-neutral-700 dark:text-neutral-300 flex-row mb-0', { 'inline-block': !plan.price })}
            valueClassName="text-neutral-700 dark:text-neutral-300 text-bodyMd"
            withColon={false}
            label={label}
            value={value}
            isLoading={isLoading}
            skeletonClassName="w-40"
            dataCy={`plan-${plan.id}`}
          />
        );
      })}
    </h6>
  );
};

export default SubscriptionPlans;
